import { Button, Drawer, Stack, styled, Typography } from '@mui/material';

type Props = {
  open: boolean;
  onClose: (skip: boolean) => void;
};

const instructions = [
  'Найдите хорошо освещенное место',
  'Убедитесь, что ваше лицо попадает в указанные на видео рамки',
  'После появление вопроса на экране, у вас будет 7 секунд перед тем как начнется запись',
  'Говорите громко и четко, пока идет запись',
  'Для ответа на вопрос дается одна попытка, после чего вам будет предложен следующий вопрос',
  'Постарайтесь не зачитывать вопрос вслух'
];

const StyledDrawer = styled(Drawer)(({ theme }) => ({
  '& .MuiDrawer-paper': {
    borderTopLeftRadius: theme.shape.borderRadius,
    borderTopRightRadius: theme.shape.borderRadius
  }
}));

const HelpDrawer = ({ open, onClose }: Props) => {
  return (
    <StyledDrawer open={open} onClose={() => onClose(true)} anchor="bottom">
      <Stack sx={{ p: 6 }}>
        <Typography textAlign="center" variant="h6" fontWeight="600" sx={{ mb: 5 }}>
          Инструкция по записи видео
        </Typography>
        <ol style={{ paddingLeft: 16 }}>
          {instructions.map((instruction, index) => (
            <li key={index}>
              <Typography variant="body1">{instruction}</Typography>
            </li>
          ))}
        </ol>
        <Button
          sx={{ mt: 5 }}
          size="large"
          fullWidth
          variant="contained"
          onClick={() => onClose(false)}
        >
          Понятно
        </Button>
      </Stack>
    </StyledDrawer>
  );
};

export default HelpDrawer;
